// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Msl5","col":"styles_col__ZnZR_"};